<template>
  <q-dialog v-model="Show" persistent @hide="CerrarModal">
    <q-card style="width: 750px; max-width: 95vw; max-height: 90vh; display: flex; flex-direction: column;" class="rounded-borders shadow-4">
      <!-- Encabezado Fijo del Modal -->
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-sm shrink-0">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="apartment" class="q-mr-sm" size="sm" />
          <span>Empresas Vinculadas a Licencia</span>
        </div>
        <q-btn icon="close" flat round dense v-close-popup @click="CerrarModal" />
      </q-card-section>

      <!-- Banner de la Licencia Seleccionada -->
      <q-card-section class="bg-blue-1 text-grey-9 q-pa-sm shrink-0 border-bottom">
        <div class="row items-center justify-between q-col-gutter-sm">
          <div class="col-12 col-md-6">
            <div class="text-subtitle2 text-weight-bolder text-primary">
              {{ licenciaInfo.company_name || 'Cliente sin Razón Social' }}
            </div>
            <div class="text-caption">
              RUC / DNI: <strong>{{ licenciaInfo.ruc || 'N/A' }}</strong> | Clave: <code class="bg-grey-3 q-px-xs rounded-borders">{{ licenciaInfo.license_key || 'Sin Clave' }}</code>
            </div>
            <div class="q-mt-xs row items-center q-gutter-x-xs">
              <q-badge color="primary" class="text-weight-bold">
                Tipo: {{ licenciaInfo.tipo_licencia || 'CONTABLE' }}
              </q-badge>
              <q-badge color="indigo" class="text-weight-bold">
                <q-icon name="business" class="q-mr-xs" />
                {{ empresasAsociadas.length }} Empresa(s)
              </q-badge>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="row q-col-gutter-xs items-center justify-end">
              <div class="col-7 col-sm-6">
                <q-input
                  v-model="fechaVencimiento"
                  type="date"
                  label="Vencimiento Licencia"
                  dense
                  outlined
                  class="bg-white"
                />
              </div>
              <div class="col-5 col-sm-6">
                <q-btn
                  color="secondary"
                  icon="sync"
                  label="Guardar y Sincronizar"
                  unelevated
                  no-caps
                  dense
                  class="full-width text-weight-bold q-py-xs"
                  :loading="isSyncing"
                  @click="SincronizarVencimientoLicencia"
                >
                  <q-tooltip>Actualiza el vencimiento e inserta/actualiza en serviciovencimiento2 a todas las empresas enlazadas</q-tooltip>
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>

      <!-- Cuerpo del Modal con Scroll -->
      <q-card-section class="col overflow-auto q-pa-md q-gutter-y-md">
        <!-- Formulario para Vincular Nueva Empresa -->
        <q-card flat bordered class="bg-grey-1 rounded-borders">
          <q-card-section class="q-pa-sm">
            <div class="text-caption text-weight-bold text-grey-8 q-mb-xs">
              <q-icon name="add_link" size="xs" color="primary" class="q-mr-xs" />
              Vincular Nueva Empresa a esta Licencia:
            </div>
            <div class="row q-col-gutter-sm items-center">
              <div class="col-12 col-sm-9">
                <q-select
                  v-model="empresaSeleccionada"
                  :options="empresasDisponibles"
                  option-value="ruc"
                  option-label="label"
                  emit-value
                  map-options
                  use-input
                  input-debounce="0"
                  @filter="filterEmpresas"
                  label="Seleccione Empresa por RUC o Razón Social"
                  outlined
                  dense
                  class="bg-white"
                />
              </div>
              <div class="col-12 col-sm-3">
                <q-btn
                  color="primary"
                  icon="add_link"
                  label="Vincular"
                  unelevated
                  no-caps
                  class="full-width text-weight-bold"
                  :loading="isLinking"
                  :disable="!empresaSeleccionada"
                  @click="VincularEmpresa"
                />
              </div>
            </div>
          </q-card-section>
        </q-card>

        <q-separator />

        <!-- Tabla de Empresas Vinculadas -->
        <div class="row items-center justify-between q-mb-xs">
          <div class="text-subtitle2 text-weight-bold text-grey-8">
            Empresas Enlazadas ({{ empresasAsociadas.length }}):
          </div>
          <q-input
            v-model="filterText"
            dense
            outlined
            placeholder="Filtrar vinculadas..."
            class="bg-white"
            style="max-width: 200px;"
          >
            <template v-slot:append>
              <q-icon name="search" size="xs" />
            </template>
          </q-input>
        </div>

        <q-table
          :data="empresasFiltradas"
          :columns="columns"
          row-key="ruc_empresa"
          :loading="isLoading"
          :grid="$q.screen.xs"
          flat
          bordered
          dense
          no-data-label="No hay empresas vinculadas a esta licencia actualmente"
        >
          <template v-slot:body-cell-ruc_empresa="props">
            <q-td :props="props" class="text-weight-bold">
              {{ props.value }}
            </q-td>
          </template>

          <template v-slot:body-cell-acciones="props">
            <q-td :props="props" class="text-center">
              <q-btn
                flat
                round
                dense
                color="negative"
                icon="link_off"
                @click="DesvincularEmpresa(props.row)"
              >
                <q-tooltip>Desvincular Empresa de la Licencia</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </q-table>
      </q-card-section>

      <!-- Pie del Modal Fijo -->
      <q-card-actions align="right" class="q-pa-md bg-grey-1 shrink-0">
        <q-btn
          flat
          label="Cerrar"
          color="grey-8"
          no-caps
          @click="CerrarModal"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "LicenciaEmpresasModal",
  props: {
    DialogEmpresas: {
      type: Boolean,
      required: true,
      default: false,
    },
    Licencia: {
      type: Object,
      required: false,
      default: () => ({
        license_key: "",
        ruc: "",
        company_name: "",
        tipo_licencia: "",
      }),
    },
  },
  data() {
    return {
      Show: this.DialogEmpresas,
      isLoading: false,
      isLinking: false,
      isSyncing: false,
      fechaVencimiento: "",
      empresaSeleccionada: null,
      filterText: "",
      empresasAsociadas: [],
      empresasDisponiblesRaw: [],
      empresasDisponibles: [],
      columns: [
        { name: "ruc_empresa", label: "RUC Empresa", field: "ruc_empresa", align: "left", sortable: true },
        { name: "razonsocial", label: "Razón Social", field: "razonsocial", align: "left", sortable: true },
        { name: "telefono", label: "Teléfono", field: row => row.telefono || "-", align: "left" },
        { name: "email", label: "Email", field: row => row.email || "-", align: "left" },
        { name: "fechacrea", label: "Fecha Enlace", field: row => this.formatFecha(row.fechacrea), align: "center" },
        { name: "acciones", label: "Acciones", field: "acciones", align: "center" },
      ],
    };
  },
  computed: {
    licenciaInfo() {
      return this.Licencia || {};
    },
    empresasFiltradas() {
      if (!this.filterText) return this.empresasAsociadas;
      const term = this.filterText.toLowerCase();
      return this.empresasAsociadas.filter(
        (item) =>
          (item.ruc_empresa && item.ruc_empresa.toLowerCase().includes(term)) ||
          (item.razonsocial && item.razonsocial.toLowerCase().includes(term))
      );
    },
  },
  watch: {
    DialogEmpresas(val) {
      this.Show = val;
      if (val && this.licenciaInfo && (this.licenciaInfo.license_key || this.licenciaInfo.ruc)) {
        this.initFecha();
        this.CargarEmpresas();
      }
    },
    Licencia: {
      handler(newVal) {
        if (this.Show && newVal && (newVal.license_key || newVal.ruc)) {
          this.initFecha();
          this.CargarEmpresas();
        }
      },
      deep: true,
    },
  },
  methods: {
    initFecha() {
      if (this.licenciaInfo && this.licenciaInfo.expiry_date) {
        const d = this.licenciaInfo.expiry_date;
        this.fechaVencimiento = typeof d === "string" ? d.split("T")[0] : "";
      } else {
        this.fechaVencimiento = "";
      }
    },
    CargarEmpresas() {
      let me = this;
      const lic = me.licenciaInfo;
      if (!lic.license_key && !lic.ruc) return;

      me.isLoading = true;
      me.initFecha();
      const payload = {
        license_key: lic.license_key || "",
        ruc_licencia: lic.ruc || "",
      };

      axios
        .post("ApiWeb/LicenciaEmpresaListar.php", payload)
        .then((res) => {
          if (res.data && res.data.data) {
            me.empresasAsociadas = res.data.data.asociadas || [];
            me.empresasDisponiblesRaw = res.data.data.disponibles || [];
            me.empresasDisponibles = [...me.empresasDisponiblesRaw];
          }
        })
        .catch((err) => {
          console.error("Error CargarEmpresas:", err);
        })
        .finally(() => {
          me.isLoading = false;
        });
    },
    filterEmpresas(val, update) {
      update(() => {
        if (val === "") {
          this.empresasDisponibles = this.empresasDisponiblesRaw;
        } else {
          const needle = val.toLowerCase();
          this.empresasDisponibles = this.empresasDisponiblesRaw.filter(
            v => v.label.toLowerCase().indexOf(needle) > -1
          );
        }
      });
    },
    VincularEmpresa() {
      if (!this.empresaSeleccionada) {
        this.notificar("Seleccione una empresa para vincular", "warning");
        return;
      }

      let me = this;
      me.isLinking = true;
      const lic = me.licenciaInfo;
      const payload = {
        license_key: lic.license_key || "",
        ruc_licencia: lic.ruc || "",
        ruc_empresa: me.empresaSeleccionada,
      };

      axios
        .post("ApiWeb/LicenciaEmpresaAgregar.php", payload)
        .then((res) => {
          if (res.data && res.data.error) {
            me.notificar(res.data.mensaje || "Error al vincular empresa", "negative");
          } else {
            me.notificar(res.data.mensaje || "Empresa vinculada correctamente", "positive");
            me.empresaSeleccionada = null;
            me.CargarEmpresas();
            me.$emit("EmpresasActualizadas");
          }
        })
        .catch((err) => {
          console.error("Error VincularEmpresa:", err);
          me.notificar("Error de conexión al vincular empresa", "negative");
        })
        .finally(() => {
          me.isLinking = false;
        });
    },
    DesvincularEmpresa(row) {
      if (confirm(`¿Desea desvincular la empresa "${row.razonsocial || row.ruc_empresa}" de esta licencia?`)) {
        let me = this;
        const lic = me.licenciaInfo;
        const payload = {
          id: row.id || 0,
          license_key: lic.license_key || "",
          ruc_empresa: row.ruc_empresa,
        };

        axios
          .post("ApiWeb/LicenciaEmpresaEliminar.php", payload)
          .then((res) => {
            if (res.data && !res.data.error) {
              me.notificar("Empresa desvinculada", "positive");
              me.CargarEmpresas();
              me.$emit("EmpresasActualizadas");
            } else {
              me.notificar(res.data.mensaje || "Error al desvincular", "warning");
            }
          })
          .catch((err) => {
            console.error("Error DesvincularEmpresa:", err);
          });
      }
    },
    SincronizarVencimientoLicencia() {
      const lic = this.licenciaInfo;
      if (!lic.license_key) {
        this.notificar("Clave de licencia no válida", "warning");
        return;
      }
      if (!this.fechaVencimiento) {
        this.notificar("Seleccione una fecha de vencimiento válida", "warning");
        return;
      }

      let me = this;
      me.isSyncing = true;
      const payload = {
        license_key: lic.license_key,
        expiry_date: me.fechaVencimiento,
        tipo_licencia: lic.tipo_licencia || "CONTABLE",
      };

      axios
        .post("ApiWeb/LicenciaEmpresaSincronizar.php", payload)
        .then((res) => {
          if (res.data && !res.data.error) {
            me.notificar(res.data.mensaje || "Vencimiento actualizado y sincronizado a todas las empresas enlazadas", "positive");
            if (me.Licencia) {
              me.Licencia.expiry_date = me.fechaVencimiento;
            }
            me.CargarEmpresas();
            me.$emit("EmpresasActualizadas");
          } else {
            me.notificar(res.data.mensaje || "Error al sincronizar vencimientos", "negative");
          }
        })
        .catch((err) => {
          console.error("Error SincronizarVencimientoLicencia:", err);
          me.notificar("Error de conexión al sincronizar vencimiento", "negative");
        })
        .finally(() => {
          me.isSyncing = false;
        });
    },
    formatFecha(fecha) {
      if (!fecha) return "-";
      return new Date(fecha).toLocaleDateString("es-PE");
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000,
        });
      } else {
        alert(msg);
      }
    },
    CerrarModal() {
      this.Show = false;
      this.$emit("CerrarModal");
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}
</style>
